import { render, staticRenderFns } from "./PageCardContent.vue?vue&type=template&id=3b7e9eaa&scoped=true"
import script from "./PageCardContent.vue?vue&type=script&lang=js"
export * from "./PageCardContent.vue?vue&type=script&lang=js"
import style0 from "./PageCardContent.vue?vue&type=style&index=0&id=3b7e9eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e9eaa",
  null
  
)

export default component.exports